module.exports = __webpack_public_path__ + "img/drBAop7Hdn-cropped.7d498089.gif";